export enum OddsFormat {
  Decimal = "Decimal",
  Fractional = "Fractional",
  American = "American",
}